import React, { useState } from 'react'
import { connect as connectRedux } from 'react-redux'
import { connect as connectStaticText } from 'components/StaticText/connect'
import SocialButton, { SOCIAL_BUTTON_TYPES, SOCIAL_BUTTON_SIZES } from 'components/SocialButton'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { openWindow, SHARE_LINKS } from 'services/share'
import { URL_GO_PAGE } from 'services/url/constants'
import { TextInput } from 'components/FormInput.v2'
import Button, { TYPES } from 'components/Button'
import { TARGET_BLANK } from 'components/Link'
import { H3, H6 } from 'components/Heading'
import { get as getConfig } from 'config'
import compose from 'recompose/compose'
import FormsyForm from 'formsy-react'
import PropTypes from 'prop-types'
import _get from 'lodash/get'
import { List } from 'immutable'

const config = getConfig()
const myLibraryGQLEnabled = !!_get(config, ['features', 'myLibraryPageGraphQL'])

const MultiplePlaylistsShareModal = (props) => {
  const {
    staticText,
    playlistName,
    playlistItems,
    playListItemsGraphql,
  } = props

  const [sharePlaylistName, setPlaylistName] = useState(playlistName)
  const [sharePlaylistItems] = useState(myLibraryGQLEnabled ? playListItemsGraphql : playlistItems)
  const [shareLink, setShareLink] = useState(getPlaylistShareLink)

  function shareMedia (siteUrl) {
    return (e) => {
      e.preventDefault()
      const encodeURL = encodeURIComponent(shareLink)
      const destinationURL = siteUrl.replace('{url}', encodeURL)
        .replace('{title}', sharePlaylistName)
        .replace('{user_id}', SHARE_LINKS.GAIA_USER)

      if (siteUrl.includes('mailto')) {
        window.location.href = destinationURL
      } else {
        openWindow(null, true, destinationURL)
      }
    }
  }

  function getPlaylistShareLink () {
    const contentIds = sharePlaylistItems.join(',')
    const globalURL = _get(config, 'origin')
    const encodedPlaylistName = encodeURIComponent(sharePlaylistName)
    return `${globalURL}${URL_GO_PAGE}?playlistCreate=${encodedPlaylistName}&contentIds=${contentIds}`
  }

  function handleChange (value) {
    setPlaylistName(value)
  }

  function savePlaylistName () {
    setShareLink(getPlaylistShareLink)
  }

  return (
    <div className="multiple-playlists-share-modal">
      <div className="multiple-playlists-share-modal__header">
        <H3>{staticText.getIn(['data', 'title'])}</H3>
        <p>{staticText.getIn(['data', 'instructions'])}</p>
      </div>

      <FormsyForm className="multiple-playlists-share-modal__form">
        <div className="multiple-playlists-share-modal__name-playlist">
          <H6>{staticText.getIn(['data', 'namePlaylist'])}</H6>
          <TextInput
            label={staticText.getIn(['data', 'namePlaylist'])}
            autocomplete="off"
            onChange={handleChange}
            value={sharePlaylistName}
            name="namePlaylist"
            block
          />
          <Button
            type={TYPES.PRIMARY}
            className="multiple-playlists-share-modal__save-name"
            onClick={savePlaylistName}
            inverted
          >
            {staticText.getIn(['data', 'saveName'])}
          </Button>
        </div>
        <div className="multiple-playlists-share-modal__share-link">
          <H6>{staticText.getIn(['data', 'shareLink'])}</H6>
          <TextInput
            label={staticText.getIn(['data', 'shareLink'])}
            autocomplete="off"
            value={shareLink}
            name="copyPlaylistLink"
            copyable
            readonly
            block
          />
        </div>

        <div className="multiple-playlists-share-modal__more-options">
          <H6>{staticText.getIn(['data', 'moreOptions'])}</H6>
          <div className="multiple-playlists-share-modal__social-buttons">
            <div className="multiple-playlists-share-modal__social-buttons--reddit">
              <SocialButton
                size={SOCIAL_BUTTON_SIZES.MEDIUM}
                type={SOCIAL_BUTTON_TYPES.REDDIT}
                target={TARGET_BLANK}
                onClick={shareMedia(SHARE_LINKS.REDDIT)}
              />
            </div>
            <div className="multiple-playlists-share-modal__social-buttons--twitter">
              <SocialButton
                size={SOCIAL_BUTTON_SIZES.MEDIUM}
                type={SOCIAL_BUTTON_TYPES.TWITTER}
                target={TARGET_BLANK}
                onClick={shareMedia(SHARE_LINKS.TWITTER)}
              />
            </div>
            <div className="multiple-playlists-share-modal__social-buttons--facebook">
              <SocialButton
                size={SOCIAL_BUTTON_SIZES.MEDIUM}
                type={SOCIAL_BUTTON_TYPES.FACEBOOK}
                target={TARGET_BLANK}
                onClick={shareMedia(SHARE_LINKS.FACEBOOK)}
              />
            </div>
            <div className="multiple-playlists-share-modal__social-buttons--email">
              <SocialButton
                size={SOCIAL_BUTTON_SIZES.MEDIUM}
                type={SOCIAL_BUTTON_TYPES.EMAIL}
                target={TARGET_BLANK}
                onClick={shareMedia(SHARE_LINKS.EMAIL)}
              />
            </div>
          </div>
        </div>
      </FormsyForm>
    </div>
  )
}

MultiplePlaylistsShareModal.propTypes = {
  auth: ImmutablePropTypes.map.isRequired,
  playlistItems: ImmutablePropTypes.list.isRequired,
  playlistName: PropTypes.string.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
}

export default compose(
  connectStaticText({ storeKey: 'multiplePlaylistsShareModal' }),
  connectRedux(
    (state) => ({
      auth: state.auth,
      playlistItems: state.tiles.getIn(['playlistUser', 'data', 'titles'], List()).map((video) => video.get('id')),
    }),
  ),
)(MultiplePlaylistsShareModal)
